<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? `Edit Fee Configuration` : "Add Fee Configuration" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              v-model.trim="form.particular"
              label="Particular*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model.trim="form.fee"
              label="Fee*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-checkbox
              v-model="form.search_fee_applicable"
              label="Search Fee Applicable"
              dense
              hide-details
              class="mt-0"
              @change="form.search_fee = 0"
            />
            <v-checkbox
              v-model="form.postal_fee_applicable"
              label="Postal Fee Applicable"
              dense
              hide-details
              class="mt-0"
              @change="form.postal_fee = 0"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-if="form.search_fee_applicable"
              v-model.trim="form.search_fee"
              label="Search Fee"
              outlined
              dense
              hide-details="auto"
              class="mt-3"
            />
            <v-text-field
              v-if="form.postal_fee_applicable"
              v-model.trim="form.postal_fee"
              label="Postal Fee"
              outlined
              dense
              hide-details="auto"
              class="mt-3"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-switch
              v-model="form.is_visible"
              label="Visible to Students"
              hide-details="auto"
              class="mt-n1"
            ></v-switch>
            <div class="caption grey--text">
              Enable this option to allow students to view and request this
              document.
            </div>
          </v-col>

          <!-- Student Status Multi Select -->
          <v-col cols="12" md="6" v-if="form.is_visible">
            <v-select
              v-model="form.student_status"
              :items="studentStatuses"
              item-text="text"
              item-value="value"
              label="Applicable Student Status"
              hide-details="auto"
              multiple
              chips
              small-chips
              clearable
              outlined
              dense
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">
          {{ edit ? "Update" : "Save" }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    miscellaneousFee: {
      type: Object,
      default: () => ({}),
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules,
      form: {
        particular: "",
        fee: "0",
        search_fee_applicable: false,
        search_fee: "0",
        postal_fee_applicable: false,
        postal_fee: "0",
        is_visible: false,
        student_status: [],
      },
      studentStatuses: [
        { text: "Active", value: "A" },
        { text: "Inactive", value: "I" },
        { text: "Graduated", value: "X" },
      ],
    };
  },
  watch: {
    // "form.is_visible"(val) {
    //   console.log(this.form.student_status)
    //   if (val && (this.form?.student_status == null || this.form.student_status.length === 0)) {
    //     this.form.student_status = ["A", "I", "X"];
    //   }
    // },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.edit && this.miscellaneousFee) {
        this.form = { ...this.miscellaneousFee };
        this.form.fee = this.form.fee.toString();
      }
    },
    save() {
      if(!this.form.is_visible){
        this.form.student_status = [];
      }
      if (!this.$refs.form.validate()) return;

      if (this.edit) {
        this.$emit("update", this.form);
      } else {
        this.$emit("create", this.form);
      }
    },
  },
};
</script>

<style scoped></style>
